export const AssociationDashboardSummarySelector = ({
  associationDashboard :
    { AssociationDashboardSummary }
}) => AssociationDashboardSummary;

export const AssociationDashboardChangeLogSelector = ({
  associationDashboard:
    { AssociationDashboardChangeLog }
}) => AssociationDashboardChangeLog;
